import "./Spinner.css";

export default function SpinnerCircle() {
  return <span className="loader"></span>;
}
